import BasicText from "@/components/BasicText";
import LButton from "@/components/LButton";
import Subtitle from "@/components/Subtitle";
import Title from "@/components/Title";

import Image from "@/components/Image";
import heroImage from "@/assets/images/node-hero.png";
import maskGroup from "@/assets/images/node-hero-mask-group.png";
import backgroundImage from "@/assets/images/node-hero-background.png";
import BigEllipse from "@/components/svg/ellipse/BigEllipse";

const Hero: React.FC = () => {
  return (
    <section className="flex max-h-[655px] relative">
      <div className="mx-20 mt-32 z-20">
        <Subtitle>// $NODE</Subtitle>
        <Title className="mt-2 lg:text-[42px]">
          <h1>Introducing $NODE</h1>
          <h1 className="lg:mx-14 text-luminode-blue">Powering Our Future</h1>
        </Title>

        <BasicText className="mt-4" size="18px" color="faded" >
          <div className="max-w-[340px] lg:max-w-[430px] xl:max-w-[480px]">
            $NODE empowers users with unmatched security, scalability, and
            utility in the emerging world of Web3.
          </div>
        </BasicText>

        <div className="w-fit mt-8">
          <LButton luminodeicon push_down>
            <div className="text-[16px]">Buy $NODE</div>
          </LButton>
        </div>
      </div>

      <div className="invisible md:visible">
        <Image
          src={backgroundImage}
          alt="background image"
          className="absolute z-0 right-[30px] top-[-200px] max-w-[998px] opacity-40"
        />
        <Image
          src={maskGroup}
          alt="background image"
          className="absolute w-[60vw] right-[0] top-14 z-0"
        />
        <Image
          src={heroImage}
          alt="background image"
          className="absolute bottom-[20px] right-[7%] z-10 max-w-[533px]"
        />

      </div>
    </section>
  );
};

export default Hero;
